import type { ProposalModalityInfo } from '@/shared/api/resources';
import { Card, CardBody, CardHeader } from '@/shared/ui/Card';

export interface QuoteConfigValues {
  premium_locked: boolean;
  big_risk: boolean;
  monitoring: boolean;
  step_in: boolean;
}

/**
 * Configuracao da cotacao: as quatro caixas do OnPoint.
 *
 * As caixas sao guardadas e mostradas. O que cada uma decide e regra pendente
 * (SUB-013 e RES-003) ou sem fonte (o bloqueio do premio), e por isso nenhuma muda
 * calculo nem esteira. A modalidade diz se habilita cada caixa (configuracao da
 * modalidade, P-PAR-1), e a tela so avisa: a regra que barraria a caixa tambem e
 * pendente.
 */
export function QuoteConfigSection({
  values,
  onChange,
  disabled,
  modality,
}: {
  values: QuoteConfigValues;
  onChange: (values: QuoteConfigValues) => void;
  disabled: boolean;
  modality?: ProposalModalityInfo | null | undefined;
}) {
  const caixas: {
    chave: keyof QuoteConfigValues;
    rotulo: string;
    habilitada?: boolean | undefined;
  }[] = [
    { chave: 'premium_locked', rotulo: 'Bloquear alteracoes de valores de premio' },
    { chave: 'big_risk', rotulo: 'Grande risco', habilitada: modality?.is_large_risk },
    {
      chave: 'monitoring',
      rotulo: 'Monitoramento',
      habilitada: modality?.is_monitored,
    },
    {
      chave: 'step_in',
      rotulo: 'Retoma de objeto (Step-in)',
      habilitada: modality?.allows_step_in,
    },
  ];

  return (
    <Card>
      <CardHeader
        title="Configuracao"
        description="Guardadas e sem efeito no calculo: o que cada caixa decide ainda depende de regra da seguradora."
      />
      <CardBody className="grid gap-3 sm:grid-cols-2">
        {caixas.map((caixa) => (
          <label
            key={caixa.chave}
            className="flex cursor-pointer items-start gap-2 text-sm text-ink-700"
          >
            <input
              type="checkbox"
              checked={values[caixa.chave]}
              disabled={disabled}
              onChange={(event) =>
                onChange({ ...values, [caixa.chave]: event.target.checked })
              }
              className="mt-0.5 size-4 rounded border-line-strong text-brand-500 focus:ring-brand-500/25"
            />
            <span>
              {caixa.rotulo}
              {modality && caixa.habilitada === false ? (
                <span className="block text-2xs text-ink-500">
                  A configuracao ativa da modalidade nao habilita esta caixa.
                </span>
              ) : null}
            </span>
          </label>
        ))}
      </CardBody>
    </Card>
  );
}
